import { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";

const REACT_APP_SERVER_URL = process.env.REACT_APP_SERVER_URL;

function Notification({ onClose, showSnackbar }) {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [type, setType] = useState("");
  const [loader, setLoader] = useState(false);

  const handleSendNotification = async () => {
    if (!subject || !body) {
      showSnackbar("Subject & Body is required!", "error");
      return;
    }
    try {
      setLoader(true);
      const res = await fetch(`${REACT_APP_SERVER_URL}/global_notification`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          subject,
          body,
          type,
        }),
      }).then((res) => res.json());
      console.log("res", res);
      if (res.status === 200) {
        showSnackbar(res.msg, "success");
        onClose(false);
        setLoader(false);
        setSubject("");
        setBody("");
        setType("");
      } else {
        showSnackbar(res.msg, "error");
      }
      showSnackbar(res.msg, "success");
    } catch (error) {
      console.error("Notification failed", error);
    }
  };

  return (
    <>
      <div>
        <Box
          sx={{
            position: "absolute",
            top: 70,
            right: 40,
            width: 350,
            p: 2,
            boxShadow: 3,
            borderRadius: 2,
            backgroundColor: "#fff",
            zIndex: 1000,
          }}
        >
          <Typography variant="h6" mb={2}>
            Push Notification
          </Typography>
          <TextField
            fullWidth
            label="Subject"
            size="small"
            margin="dense"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
          <TextField
            fullWidth
            label="Body"
            size="small"
            margin="dense"
            multiline
            rows={3}
            value={body}
            onChange={(e) => setBody(e.target.value)}
          />
          <TextField
            fullWidth
            label="Type"
            size="small"
            margin="dense"
            placeholder="optional"
            value={type}
            onChange={(e) => setType(e.target.value)}
          />
          <Box mt={2} display="flex" justifyContent="space-between">
            <Button
              variant="outlined"
              size="small"
              onClick={() => onClose(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={handleSendNotification}
            >
              {loader ? <CircularProgress size={24} /> : "Send"}
            </Button>
          </Box>
        </Box>
      </div>
    </>
  );
}

export default Notification;
